import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ChevronsUpDownIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6.29497 20.4843L14.908 30.4845C15.5001 31.1718 16.4999 31.1718 17.092 30.4845L25.705 20.4843C26.3521 19.7329 25.8647 18.5 24.9205 18.5H7.07962C6.13531 18.5 5.64786 19.7329 6.29497 20.4843Z"
        fill="currentColor"
      />
      <path
        d="M6.29497 11.5157L14.908 1.51561C15.5001 0.82813 16.4999 0.82813 17.092 1.51561L25.705 11.5157C26.3521 12.2671 25.8647 13.5 24.9205 13.5H7.07962C6.13531 13.5 5.64786 12.2671 6.29497 11.5157Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
